import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const testimonials = [{
    quote: 'The team at Edvin provided exceptional care for my mother. Their compassion and professionalism gave our family peace of mind.',
    author: 'Sarah M.'
  }, {
    quote: 'I cannot thank Edvin Home Healthcare enough for the wonderful care they provided. The nurses were kind, skilled, and truly caring.',
    author: 'James R.'
  }, {
    quote: 'Finding Edvin was a blessing. They treated my father with such dignity and respect. I would recommend them to anyone.',
    author: 'Maria L.'
  }];
  return <section id="testimonials" className="py-20 md:py-28 bg-light-alt relative overflow-hidden" data-id="element-318">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-319"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-320"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-321">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-322">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-323">
            <div className="mb-8 rounded-2xl overflow-hidden shadow-card mx-auto max-w-2xl" data-id="element-324">
              <img src="https://cdn.magicpatterns.com/uploads/d6jS4Kkp3VskdBgjLTMsA2/3.jpg" alt="Happy seniors enjoying life together" className="w-full h-52 object-cover" data-id="element-325" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-326">
              What Our Clients Say
            </h2>
            <div className="w-20 h-1.5 bg-secondary mx-auto mb-6 rounded-full" data-id="element-327"></div>
            <p className="text-lg text-dark-muted" data-id="element-328">
              Trusted by families across the community
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-329">
            {testimonials.map((testimonial, idx) => <div key={idx} className="bg-white rounded-2xl p-8 shadow-card relative mt-8 pt-12" data-id="element-330">
                <div className="absolute -top-6 left-8 bg-primary text-white p-3 rounded-xl shadow-lg" data-id="element-331">
                  <QuoteIcon className="h-6 w-6" data-id="element-332" />
                </div>

                <div className="flex space-x-1 mb-6" data-id="element-333">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-secondary-orange fill-current" data-id="element-334" />)}
                </div>

                <p className="text-dark-muted text-lg italic mb-8 leading-relaxed" data-id="element-335">
                  "{testimonial.quote}"
                </p>

                <div className="flex items-center" data-id="element-336">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold mr-4" data-id="element-337">
                    {testimonial.author.charAt(0)}
                  </div>
                  <h4 className="font-bold text-dark" data-id="element-338">{testimonial.author}</h4>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}